import 'date-fns';
import React from 'react';
import { DatePicker } from '@mui/x-date-pickers';
import dayjs, { Dayjs } from 'dayjs';
import { hasValue } from '../inputs/inputHelpers';
import { useTheme } from '@mui/material/styles';

interface IProps {
  onChange: (date: Date | null) => any
  value: Date | null
  label?: string
  name?: string
  variant?: 'inline'
  inputVariant?: 'standard' | 'outlined' | 'filled'
  size?: 'small' | 'medium';
  fullWidth?: boolean;
  inputFormat?: string;

  error?: boolean;
  helperText?: string;
}

export default function PDateInput({ value = null, onChange, label, size, fullWidth = true, error, helperText, inputVariant, inputFormat = 'DD/MM/YYYY', ...props }: IProps) {
  const theme = useTheme();

  const handleChange = (date: Dayjs | null) => {
    if (date === null) {
      onChange(null);
    } else {
      onChange(date.toDate());
    }
  };

  return (
      <DatePicker
          label={label}
          value={hasValue(value) ? dayjs(value) : null}
          onChange={handleChange}
          format={inputFormat}
          slotProps={{
            textField: {
              variant: inputVariant,
              size,
              fullWidth,
              error,
              helperText
            },
            layout: {
              sx: {
                boxShadow: theme.shadows[10],
                borderRadius: '16px'
              }
            }
          }}
          {...props}
      />
  );
}
